import React, {useMemo} from "react";
import objectPath from "object-path";
// LayoutContext
// Import Layout components
import {LayoutInit} from "./LayoutInit";

export function Layout({ children }) {
    return  <div className="d-flex flex-column flex-root">{children}</div>
}
